import { Button, SvgIcon } from '@salecycle/ui-component-library';
import { CampaignStatus } from '../CampaignStatus';
import styled from 'styled-components';
import { useUpdateCampaignStatus } from '../../hooks/useUpdateCampaignStatus';
import { useTranslation } from 'react-i18next';
import { useCampaignEditorContext } from '../../state/hooks/useCampaignEditorContext';
import { OffsiteCampaignStatus } from 'models/offsite/Campaign/LifeCycle';
import { useCampaignValidator } from '../../hooks/useCampaignValidator';

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  width: 100%;
`;

export const CampaignDrawerFooter = () => {
  const { t } = useTranslation('campaigns');
  const { state } = useCampaignEditorContext();
  const { isValidCampaign } = useCampaignValidator();
  const { updateStatus, isLoading } = useUpdateCampaignStatus();

  return (
    <Footer>
      <CampaignStatus />
      {state.status === 'DRAFT' && (
        <Button
          leftSideIcon={<SvgIcon name="paper-plane" />}
          ariaLabel={t('bulkRetargetingCampaigns.editor.launchCampaignAria')}
          onClick={() => updateStatus(OffsiteCampaignStatus.Scheduled)}
          disabled={isLoading || state.hasUnsavedChanges || !isValidCampaign}
        >
          {t('bulkRetargetingCampaigns.editor.launchCampaign')}
        </Button>
      )}
    </Footer>
  );
};
